<template>
    <div v-if="loaded && cart.products.length">
        <div class="border p-3">
            <div class="lead mb-3 fw-bold">{{ t.cart.summary }}</div>
            <div class="row">
                <div class="col-6 fw-bold">{{ t.cart.subtotal }}</div>
                <div class="col-6">{{ amountWithCurrency(cart.subtotal) }}</div>
            </div>
            <div
                class="py-2 text-secondary"
                v-if="config.modules.voucher && loaded && cart.vouchers.length"
            >
                <div class="row">
                    <div class="col-6 fw-bold">{{ t.vouchers.vouchers }}</div>
                    <div class="col-6"></div>
                </div>
                <div
                    class="row small mb-1"
                    v-for="voucher in cart.vouchers"
                    :key="voucher.id"
                >
                    <div class="col-6">
                        {{ voucher.label }}
                        <div>
                            (<b>{{voucher.code}}</b>)
                        </div>
                    </div>
                    <div class="col align-self-end">
                        -{{ amountWithCurrency(voucher.amount) }}
                        <i class="fas fa-trash small cursor-pointer ms-2"
                        @click="deleteVoucher(voucher)"
                        ></i>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6 fw-bold">{{ t.cart.shipping }}</div>
                <div class="col-6 align-self-end">{{ amountWithCurrency(cart.shipping) }}</div>
            </div>
            <div class="row" v-if="config.modules.gift && cart.total_gift">
                <div class="col-6 fw-bold">{{ t.cart.total_gift }}</div>
                <div class="col-6 align-self-end">{{ amountWithCurrency(cart.total_gift) }}</div>
            </div>
            <div class="row my-3">
                <div class="col-6 fw-bold text-uppercase">
                    {{ t.cart.total }}
                </div>
                <div class="col-6 align-self-end fw-bold">
                    {{ cart.total ? amountWithCurrency(cart.total) : t.free }}
                </div>
            </div>
            <div class="row text-secondary" v-if="config.modules.rewards_points && cart.total_rewards_points">
                <div class="col-6 fw-bold">{{ t.rewards_points.total_points }}</div>
                <div class="col-6 align-self-end">{{ cart.total_rewards_points+' '+t.rewards_points.points }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                config: window.config,
                t: window.t,
                voucher: ''
            }
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'cart']),
        },
        methods: {
            ...Vuex.mapActions(['deleteVoucher']),
        }
    }
</script>
